var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.002a4 4 0 0 1 3.771 2.667 1 1 0 0 1-1.84.774l-.045-.108a2 2 0 0 0-3.88.517l-.005.15V8l7.749.001a2.25 2.25 0 0 1 2.245 2.096l.005.154v9.497a2.25 2.25 0 0 1-2.096 2.244l-.154.006H6.25a2.25 2.25 0 0 1-2.245-2.096L4 19.748V10.25a2.25 2.25 0 0 1 2.096-2.244L6.25 8h1.751V6A3.999 3.999 0 0 1 12 2.002Zm0 11.499a1.499 1.499 0 1 0 0 2.997 1.499 1.499 0 0 0 0-2.997Z",
    fill: "#666"
  })));
};
export default SvgUnlock;